import { useEffect, useState } from 'react';
import { inboxApi } from '../lib/api';

// Is this tenant WP-backed (Bekesher)? Drives gating of native Customer 360 /
// Manage lines in the agent UI. Cached per tenant for the session — the answer
// is static, so we probe /agent/wp/config once.
const cache = new Map<string, boolean>();
const inflight = new Map<string, Promise<boolean>>();

export function useWpConfigured(tenantCode: string | undefined): boolean | undefined {
  const [val, setVal] = useState<boolean | undefined>(
    tenantCode ? cache.get(tenantCode) : undefined
  );

  useEffect(() => {
    if (!tenantCode) return;
    const cached = cache.get(tenantCode);
    if (cached !== undefined) {
      setVal(cached);
      return;
    }
    let cancelled = false;
    let p = inflight.get(tenantCode);
    if (!p) {
      p = inboxApi
        .wpConfig(tenantCode)
        .then((r) => r.configured)
        .catch(() => false);
      inflight.set(tenantCode, p);
    }
    p.then((configured) => {
      cache.set(tenantCode, configured);
      inflight.delete(tenantCode);
      if (!cancelled) setVal(configured);
    });
    return () => {
      cancelled = true;
    };
  }, [tenantCode]);

  return val;
}
